define('core/utils/html/isVisible',[
    'core/utils/html/getCurrentStyle',
], function (
    getCurrentStyle
) {
    'use strict';

    /**
     * Determine if an element is visible in terms of page layout.
     * NOTE: "Visible" includes elements which have no width nor height but are positioned.
     *
     * @param {Element} elem - The element to check
     * @returns {boolean} - If the element has layout effect
     */

    return function isVisible(elem) {
        return Boolean(
            elem &&
            (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length) &&
            getCurrentStyle(elem, 'visibility') !== 'hidden'
        );
    };
});

